/**
 * @fileoverview gRPC-Web generated client stub for weatherAssistant
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v6.30.2
// source: weatherAssistantProto.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as weatherAssistantProto_pb from './weatherAssistantProto_pb'; // proto import: "weatherAssistantProto.proto"


export class WeatherAssistantServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorChat = new grpcWeb.MethodDescriptor(
    '/weatherAssistant.WeatherAssistantService/Chat',
    grpcWeb.MethodType.UNARY,
    weatherAssistantProto_pb.ChatRequest,
    weatherAssistantProto_pb.ChatResponse,
    (request: weatherAssistantProto_pb.ChatRequest) => {
      return request.serializeBinary();
    },
    weatherAssistantProto_pb.ChatResponse.deserializeBinary
  );

  chat(
    request: weatherAssistantProto_pb.ChatRequest,
    metadata?: grpcWeb.Metadata | null): Promise<weatherAssistantProto_pb.ChatResponse>;

  chat(
    request: weatherAssistantProto_pb.ChatRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: weatherAssistantProto_pb.ChatResponse) => void): grpcWeb.ClientReadableStream<weatherAssistantProto_pb.ChatResponse>;

  chat(
    request: weatherAssistantProto_pb.ChatRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: weatherAssistantProto_pb.ChatResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/weatherAssistant.WeatherAssistantService/Chat',
        request,
        metadata || {},
        this.methodDescriptorChat,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/weatherAssistant.WeatherAssistantService/Chat',
    request,
    metadata || {},
    this.methodDescriptorChat);
  }

  methodDescriptorChatHistoryDelete = new grpcWeb.MethodDescriptor(
    '/weatherAssistant.WeatherAssistantService/ChatHistoryDelete',
    grpcWeb.MethodType.UNARY,
    weatherAssistantProto_pb.ChatHistoryDeleteRequest,
    weatherAssistantProto_pb.EmptyResponse,
    (request: weatherAssistantProto_pb.ChatHistoryDeleteRequest) => {
      return request.serializeBinary();
    },
    weatherAssistantProto_pb.EmptyResponse.deserializeBinary
  );

  chatHistoryDelete(
    request: weatherAssistantProto_pb.ChatHistoryDeleteRequest,
    metadata?: grpcWeb.Metadata | null): Promise<weatherAssistantProto_pb.EmptyResponse>;

  chatHistoryDelete(
    request: weatherAssistantProto_pb.ChatHistoryDeleteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: weatherAssistantProto_pb.EmptyResponse) => void): grpcWeb.ClientReadableStream<weatherAssistantProto_pb.EmptyResponse>;

  chatHistoryDelete(
    request: weatherAssistantProto_pb.ChatHistoryDeleteRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: weatherAssistantProto_pb.EmptyResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/weatherAssistant.WeatherAssistantService/ChatHistoryDelete',
        request,
        metadata || {},
        this.methodDescriptorChatHistoryDelete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/weatherAssistant.WeatherAssistantService/ChatHistoryDelete',
    request,
    metadata || {},
    this.methodDescriptorChatHistoryDelete);
  }

}

